const STATUS_MAP = {
  0: "Pendente",
  1: "Em Atendimento",
  2: "Concluída",
  3: "Contato Futuro",
  4: "Perdida",
  5: "Cancelada",
};

/** Mesmas chaves de `theme.palette.status` usadas no chat (`StatusSelector`). */
export const STATUS_COLOR_KEY_BY_CODE = {
  0: "pending",
  1: "inProgress",
  2: "success",
  3: "future",
  4: "unsuccessful",
  5: "canceled",
};

const STATUS_LIGHT_TEXT_LABELS = new Set(["Concluída", "Perdida", "Cancelada"]);

/** Normaliza qualquer entrada para um código de status 0–5. */
export function normalizeStatusCode(status) {
  if (status === null || status === undefined) return 0;
  if (status === "" || status === "0" || status === 0) return 0;
  if (typeof status === "string" && isNaN(Number(status))) {
    const entry = Object.entries(STATUS_MAP).find(([, label]) => label === status);
    return entry ? Number(entry[0]) : 0;
  }
  const n = typeof status === "string" ? Number(status) : status;
  return Number.isFinite(n) && n >= 0 && n <= 5 ? n : 0;
}

/**
 * Converte código numérico ou string do status em rótulo legível.
 *
 * Aceita:
 * - código numérico (0–5)
 * - string numérica ("0"–"5")
 * - rótulo já formatado ("Pendente", "Em Atendimento", etc.)
 *
 * @param {number|string} status
 * @returns {string}
 */
export const getStatusLabelFromCode = (status) => {
  if (typeof status === "string" && isNaN(Number(status))) {
    return STATUS_MAP[normalizeStatusCode(status)] ?? status;
  }
  const n = typeof status === "string" ? Number(status) : status;
  return STATUS_MAP[n] ?? "Desconhecido";
};

/**
 * Cores de fundo e texto do chip de status (mesmo padrão do chat).
 * @returns {{ label: string, bg: string, color: string } | null}
 */
export function getStatusPaletteStyles(status, theme) {
  const code = normalizeStatusCode(status);
  const label = STATUS_MAP[code];
  if (!label) return null;

  const colorKey = STATUS_COLOR_KEY_BY_CODE[code];
  const bg = theme.palette.status?.[colorKey];
  if (!bg) return null;

  const color = STATUS_LIGHT_TEXT_LABELS.has(label)
    ? theme.palette.common.white
    : theme.palette.text.primary;

  return { label, bg, color };
}

/**
 * Mensagem amigável para falha ao alterar status de solicitação (corpo `{ message }` da API).
 */
export function getRequestStatusChangeErrorMessage(err, fallbackMessage) {
  const msg = typeof err?.message === "string" ? err.message.trim() : "";
  if (msg) return msg;
  return fallbackMessage;
}

/** Cor de destaque lateral (barra) alinhada ao status. */
export function getStatusAccentColor(status, theme, { isClosed = false } = {}) {
  if (isClosed) return theme.palette.text.disabled;

  const code = normalizeStatusCode(status);
  const colorKey = STATUS_COLOR_KEY_BY_CODE[code] || "pending";
  return theme.palette.status?.[colorKey] || theme.palette.primary.main;
}
